import { ReactNode, useEffect, useState } from 'react';
import { Button, Flex, Tooltip } from '@chakra-ui/react';

type TToggleRadioButtonProps = {
    items: {
        content: string | ReactNode;
        onClick: () => void;
        tooltip?: string;
        bubble?: number;
    }[];
    defaultSelected?: number;
};

const bubbleStyle = {
    position: 'absolute',
    padding: '6px',
    top: '-10px',
    right: '-10px',
    zIndex: '2',
    backgroundColor: 'red.500',
    borderRadius: '100%',
    color: 'white',
    fontSize: '.8em',
};

const ToggleRadioButton = ({ items, defaultSelected }: TToggleRadioButtonProps) => {
    const [selected, setSelected] = useState(defaultSelected ?? 0);

    useEffect(() => {
        setSelected(defaultSelected ?? 0);
    }, [defaultSelected]);

    return (
        <Flex>
            {items.map((item, idx) => (
                <Tooltip key={idx} label={item.tooltip} placement="top">
                    <Button
                        backgroundColor={idx === selected ? 'blue.200' : 'gray.50'}
                        _hover={{ background: idx === selected ? 'blue.200' : 'gray.100' }}
                        borderRadius="none"
                        borderRightRadius={idx + 1 === items.length ? '5px' : 'none'}
                        borderLeftRadius={idx === 0 ? '5px' : 'none'}
                        borderColor="gray.200"
                        borderWidth="1px"
                        onClick={() => {
                            setSelected(idx);
                            item.onClick();
                        }}
                        _after={
                            item.bubble
                                ? {
                                      content: `"${item.bubble > 5 ? '5+' : item.bubble}"`,
                                      ...bubbleStyle,
                                  }
                                : {}
                        }
                    >
                        {item.content}
                    </Button>
                </Tooltip>
            ))}
        </Flex>
    );
};

export default ToggleRadioButton;
